import { CUSTOM_ELEMENT_NAME } from "index";

export const initDeveloperMountingTools = () => {
	// eslint-disable-next-line no-restricted-globals
	addEventListener("keydown", (event) => {
		if (!event.ctrlKey) return;

		// Unmount
		if (event.key === "0") {
			const element = document.getElementsByTagName(CUSTOM_ELEMENT_NAME);
			if (!element.length) return;
			element[0].remove();
		}

		// Mount
		if (event.key === "1") {
			const element = document.getElementsByTagName(CUSTOM_ELEMENT_NAME);
			if (element.length) return;
			const planningBoard = document.createElement("planning-board");
			planningBoard.style.cssText =
				"display: flex; flex-direction: column; flex: 1;";
			planningBoard.setAttribute("is-standalone-app", "");
			planningBoard.setAttribute("user-token", "USER_TOKEN");
			document.body.appendChild(planningBoard);
		}
	});
};
